// extracted by mini-css-extract-plugin
module.exports = {"alert":"jA","alertIcon":"jB","formContainer":"jC","formContainerInner":"jD","successIcon":"jE","footer":"jF","footerItem":"jG"};